// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyBdkV-8c88fnzbGUm1U4vlFNSHv9sJxd18',
    authDomain: 'vet-app-3752a.firebaseapp.com',
    databaseURL: 'https://vet-app-3752a.firebaseio.com',
    projectId: 'vet-app-3752a',
    storageBucket: 'vet-app-3752a.appspot.com',
    messagingSenderId: '575325982511',
    appId: '1:575325982511:web:6d86ad548ee1048967dbda',
    measurementId: 'G-J7H67HHHX5'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
